import { QuestionElementProps } from "@/components/questionnaire/components/element.type.ts";
import { EmployeeNPSElement } from "@/components/questionnaire/components/EmployeeNPSElement.tsx";
import { OpenAnswerElement } from "@/components/questionnaire/components/OpenAnswerElement.tsx";
import { GoalsElement } from "@/components/questionnaire/components/GoalsElement.tsx";
import { ScaleElement } from "@/components/questionnaire/components/ScaleElement.tsx";
import { SelectElement } from "@/components/questionnaire/components/SelectElement.tsx";
import { TextElement } from "@/components/questionnaire/components/TextElement.tsx";
import { WriteToFieldElement } from "@/components/questionnaire/components/WriteToFieldElement.tsx";
import { FileElement } from "@/components/questionnaire/components/FileElement.tsx";

import { ApiFormElementType } from "@/types/forms/form.types.ts";
import { Stack } from "@skailer-com/uikit";
import React from "react";

export const QuestionElement: React.FC<QuestionElementProps> = ({ element }) => {
  const getElement = () => {
    switch (element.type) {
      case ApiFormElementType.text:
        return <TextElement element={element} />;

      case ApiFormElementType.open_answer:
        return <OpenAnswerElement element={element} />;

      case ApiFormElementType.scale:
        return <ScaleElement element={element} />;

      case ApiFormElementType.goals:
        return <GoalsElement element={element} />;

      case ApiFormElementType.select:
        return <SelectElement element={element} />;

      case ApiFormElementType.employee_nps:
        return <EmployeeNPSElement element={element} />;

      case ApiFormElementType.write_to_field:
        return <WriteToFieldElement element={element} />;

      case ApiFormElementType.file:
        return <FileElement element={element} />;

      default:
        return null;
    }
  };

  return <Stack>{getElement()}</Stack>;
};
